export default {"src":"/_next/static/media/logo.5b6c1acd.svg","height":47,"width":47,"blurWidth":0,"blurHeight":0};